module["exports"] = ["/50#{9,16}L/", "/5[6-8]#{9,16}L/", "/56##{9,16}L/"];